import {useEffect} from 'react';
import type {StagedUploadTargetGenerateUploadResource} from 'types/graphql/default-types';

import {useMediaUploader} from './hooks/useMediaUploader';
import type {MediaUploadResult} from './hooks/useMediaUploader';

export interface MediaUploaderProps {
  resourceType?: StagedUploadTargetGenerateUploadResource;
  onMediaUploaded?(result: MediaUploadResult): void;
  onAllMediasUploaded?(results: MediaUploadResult[]): Promise<void> | void;
  /**
   * Determines whether this component should perform validation on the images prior to uploading.
   * If the validation fails, the `onImageUploaded` callback is passed the error reason
   */
  validate?: boolean;
}

interface Props extends MediaUploaderProps {
  medias: File[];
}

export const MediaUploader = ({
  medias,
  resourceType,
  onMediaUploaded,
  onAllMediasUploaded,
  validate,
}: Props) => {
  const {uploadMedia} = useMediaUploader({
    resourceType,
    onMediaUploaded,
    onAllMediasUploaded,
    validate,
  });

  useEffect(() => {
    if (medias && medias.length > 0) {
      uploadMedia(medias);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
